import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MktgLetter } from "../mktg-letter";
import { MktgLetterService } from "../mktg-letter.service";

@Component({
    selector: "app-mktg-letter",
    templateUrl: "./mktg-letter.component.html",
    styleUrls: ["./mktg-letter.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MktgLetterComponent implements OnInit {
  constructor(
    private primengConfig: PrimeNGConfig,
    private mktgLetterService: MktgLetterService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private constantService: ConstantService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    (this.formTitle = data.title),
      (this.mktgLetter = data.mktgLetter);
  }

  @Input() mktgLetter: MktgLetter;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  replacementValues = [
    {key:'{targetProformaValue}', description:'Target value of proforma'},
    {key:'{managementFee}', description:'Management fees applies to proforma'},
    {key:'{ownerFirstName}', description:'First name of owner'},
    {key:'{ownerLastName}', description:'Last name of owner'},
    {key:'{adrDevelopmentName}', description:'Development Name'},
    {key:'{adrStreet}', description:'Street Address'},
    {key:'{adrUnit}', description:'Address Unit number'},
    {key:'{adrCity}', description:'City name'}
  ];
  // data
  mktgLetterId: number;
  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  validationMessages = {
    mktgLetterId: [],
    ownerFirstName: [{ type: 'required', message: 'Required' }],
    ownerLastName: [],
    adrDevelopmentName: [],
    targetProformaValue: [],
    managementFee: [],
    para1: [{ type: 'required', message: 'Required' }],
    para2: [{ type: 'required', message: 'Required' }]
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole mktgLetter object
    if (this.mktgLetter) {
      this.mktgLetterId = this.mktgLetter.mktgLetterId;
      this.form1.patchValue(this.mktgLetter);
    }
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + this.mktgLetterId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("mktgLetter-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.mktgLetterService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("mktgLetter-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.mktgLetter = res.data.mktgLetter;
          this.doAdd.emit(this.mktgLetter);
        },
        (err: any) => {
          console.log("mktgLetter-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("mktgLetter: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.mktgLetterService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("mktgLetter-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.mktgLetter = res.data.mktgLetter;
          this.doUpdate.emit(this.mktgLetter);
        },
        (err: any) => {
          console.log("mktgLetter-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.mktgLetterService.delete(this.mktgLetter.mktgLetterId).subscribe(
        (res: any) => {
          console.log("mktgLetter-delete SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.doDelete.emit(this.mktgLetter);
        },
        (err: any) => {
          console.log("mktgLetter-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      mktgLetterId: [this.mktgLetterId],
      ownerFirstName: ['', Validators.required],
      ownerLastName: [],
      adrDevelopmentName: [],
      targetProformaValue: [],
      managementFee: [],
      para1: ['', Validators.required],
      para2: ['', Validators.required]
    });
  }
}
